// src/context/react/utils/ensureBinding.ts
var ensureBinding = (r) => {
  const runtime = r;
  if (runtime.__isBound) return;
  runtime.__internal_bindMethods?.();
  runtime.__isBound = true;
};
export {
  ensureBinding
};
//# sourceMappingURL=ensureBinding.js.map